import React, { useState } from 'react';
import { observer } from "mobx-react-lite";
import { sendSelectionMail } from "../../../../http/selectionApi";
import { IMaskInput } from "react-imask";

import sharedStyles from '../UserModals.module.css';
import styles from './FormSelection.module.css';
import sharedInputStyles from '../../../adds/AddCreateForm/AddCreateForm.module.css'
import stylesButtonAuthForm from '../FormAuth/FormAuth.module.css'
import ym from "react-yandex-metrika";

const FormSelection = observer(({ show, onHide }) => {
    const PhoneMask = "+0 (000) 000-00-00";

    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [firstDate, setFirstDate] = useState('');
    const [lastDate, setLastDate] = useState('');

    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [firstDateError, setFirstDateError] = useState('');
    const [lastDateError, setLastDateError] = useState('');

    const [isSent, setIsSent] = useState(false);

    const handleClose = () => {
        // при закрытии сбрасываем состояние формы
        setIsSent(false);
        setName('');
        setPhone('');
        setFirstDate('');
        setLastDate('');
        onHide();
    };

    const sendForm = () => {
        setNameError('');
        setPhoneError('');
        setFirstDateError('');
        setLastDateError('');

        let isValid = true;

        if (!name) {
            setNameError('Заполните поле с именем');
            isValid = false;
        }

        if (!phone || phone.length !== 18) {
            setPhoneError('Введите Ваш телефон полностью');
            isValid = false;
        }

        if (!firstDate) {
            setFirstDateError('Введите дату заезда');
            isValid = false;
        }

        if (!lastDate) {
            setLastDateError('Введите дату выезда');
            isValid = false;
        }

        if (isValid) {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('phone', phone);
            formData.append('firstDate', firstDate);
            formData.append('lastDate', lastDate);

            sendSelectionMail(formData).then(() => {
                setIsSent(true);
                ym('reachGoal','sendSelectionMail');
            }).catch(e => {
                console.error("Ошибка при отправке заявки:", e);
            });
        }
    };

    return (
        <div
            className={`${sharedStyles.modal} ${show ? sharedStyles.active : ''}`}
            onClick={handleClose}
        >
            <div className={sharedStyles.modalContent} onClick={e => e.stopPropagation()}>
                <div className={sharedStyles.customCloseButton} onClick={handleClose}>&times;</div>

                <div className={sharedStyles.formInnerWrapper}>
                    {/* фоновые круги */}
                    <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleBigCircleLeft}`}></div>
                    <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleTopLeft}`}></div>
                    <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleTopRight}`}></div>
                    <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleBottomLeft}`}></div>
                    <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleBottomRight}`}></div>
                    <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleCenter}`}></div>

                    {isSent ? (
                        <div className={styles.formSuccessContainer}>
                            <div className={sharedStyles.formDescription}>
                                <div className={styles.formLogoArea}>
                                    <div className={styles.formLogoText}>Заявка на подбор</div>
                                </div>
                                <div className={styles.formLogoArea}>
                                    <h5>
                                        Ваша заявка успешно отправлена! Мы свяжемся с
                                        Вами в ближайшее время. Фото вариантов
                                        квартир будет отправлено на Ваш WhatsApp.
                                    </h5>
                                </div>
                                <div>
                                    <button className={sharedStyles.buttonSecondary} onClick={handleClose}>
                                        Закрыть
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.formContainer}>
                            <div className={styles.formLogoArea}>
                                <div className={styles.formLogoText}>Заявка на подбор</div>
                            </div>
                            <div className={styles.formDescription}>
                                <div className={styles.formSubtitle}>
                                    Оставьте заявку и мы подберем Вам квартиру совершенно бесплатно!
                                </div>
                            </div>

                            <div className={styles.inputGroup}>
                                <input
                                    className={`${styles.formInput} ${nameError ? sharedInputStyles.errorInput : ''}`}
                                    placeholder="Ваше имя"
                                    onChange={e => setName(e.target.value)}
                                    value={name}
                                />
                                <div className={styles.errorPlaceholder}>
                                    {nameError && <div className={styles.errorText}>{nameError}</div>}
                                </div>
                            </div>

                            <div className={styles.inputGroup}>
                                <IMaskInput
                                    mask={PhoneMask}
                                    value={phone}
                                    placeholder="Ваш телефон (WhatsApp)"
                                    onAccept={(value) => setPhone(value)} // фикс
                                    className={`${styles.formInput} ${phoneError ? sharedInputStyles.errorInput : ''}`}
                                />
                                <div className={styles.helperText}>
                                    Телефон в формате: +7 (XXX) XXX-XX-XX
                                </div>
                                <div className={styles.errorPlaceholder}>
                                    {phoneError && <div className={styles.errorText}>{phoneError}</div>}
                                </div>
                            </div>

                            <div className={styles.dateGroup}>
                                <div className={styles.dateLabel}>Дата заезда и выезда</div>
                                <div className={styles.dateInputs}>
                                    <div className={styles.inputContainer}>
                                        <input
                                            type="date"
                                            className={`${styles.formInput} ${firstDateError ? sharedInputStyles.errorInput : ''}`}
                                            min="2023-01-01"
                                            onChange={e => setFirstDate(e.target.value)}
                                            value={firstDate}
                                        />
                                        <div className={styles.errorPlaceholder}>
                                            {firstDateError && <div className={styles.errorText}>{firstDateError}</div>}
                                        </div>
                                    </div>
                                    <div className={styles.inputContainer}>
                                        <input
                                            type="date"
                                            className={`${styles.formInput} ${lastDateError ? sharedInputStyles.errorInput : ''}`}
                                            min="2023-01-01"
                                            onChange={e => setLastDate(e.target.value)}
                                            value={lastDate}
                                        />
                                        <div className={styles.errorPlaceholder}>
                                            {lastDateError && <div className={styles.errorText}>{lastDateError}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <button
                                    type="button"
                                    onClick={sendForm}
                                    className={`${sharedStyles.button} ${stylesButtonAuthForm.button}`}
                                >
                                    Отправить заявку
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default FormSelection;
